module.exports = __webpack_public_path__ + "static/media/taylor.4d380127.png";